(() => {
  const formInfoList = [
    {
      formId: 'FooterForm',
      buttonId: 'js-submit-button-footer',
      redirectParam: 'footer_posted',
    },
    {
      formId: 'PageForm', // 追加する本文側フォームのID
      buttonId: 'js-submit-button-page', // 追加する本文側送信ボタンのID
      redirectParam: 'page_posted',
    },
  ];

  const checkBoxElementNameList = [
    'contact[当社製品をどちらでお知りになりましたか]',
    'contact[ご来場の目的をお選びください]',
  ];

  const googleAppsScriptUrl =
    'https://script.google.com/macros/s/AKfycbyTvFoDC-aBoUFN3FFdAEgdDZYbvPZMJb1Rd840NMKv-3UMtK2V1pdyiBXTj02FbccD/exec';

  const objectifyForm = (formArray) => {
    const returnObject = {};
    for (let i = 0; i < formArray.length; i++) {
      if (checkBoxElementNameList.includes(formArray[i]['name'])) {
        if (!returnObject[formArray[i]['name']]) {
          returnObject[formArray[i]['name']] = formArray[i]['value'] + ',';
        } else {
          returnObject[formArray[i]['name']] += formArray[i]['value'] + ',';
        }
      } else {
        returnObject[formArray[i]['name']] = formArray[i]['value'];
      }
    }
    return returnObject;
  };

  const getRedirectUrl = (param) => {
    const url = location.href.split('?')[0];
    return `${url}?${param}=true`;
  };

  const redirect = (url) => {
    location.href = url;
  };

  window.addEventListener('DOMContentLoaded', () => {
    formInfoList.forEach(({ formId, buttonId, redirectParam }) => {
      const target = document.getElementById(formId);
      const button = document.getElementById(buttonId);
      if (!target || !button) return;

      const $target = $(`#${formId} :input`);

      target.addEventListener('submit', (event) => {
        event.preventDefault();
        button.disabled = true;
        const formObject = objectifyForm($target.serializeArray());
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(key => {
          const value = sessionStorage.getItem(key);
          if (value !== null && value.trim() !== '') {
            formObject[key] = value;
          }
        });
        const postParameter = {
          method: 'POST',
          mode: 'no-cors',
          'Content-Type': 'text/plain',
          keepalive: true,
          body: JSON.stringify(formObject),
        };
        fetch(googleAppsScriptUrl, postParameter).finally(() => {
          const statusMessage = target.querySelector('.contact_status');
          if (statusMessage) {
            statusMessage.style.display = 'block';
          }
          redirect(getRedirectUrl(redirectParam));
        });
      });
    });
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  const urlParams = new URLSearchParams(window.location.search);
  const isPagePosted = urlParams.get('page_posted') === 'true';
  const isFooterPosted = urlParams.get('footer_posted') === 'true';

  if (isPagePosted) {
    const statusMessage = document.querySelector('.contact_status_page');
    if (statusMessage) {
      statusMessage.style.display = 'block';
    }
  }
  if (isFooterPosted) {
    const statusMessage = document.querySelector('.contact_status_footer');
    if (statusMessage) {
      statusMessage.style.display = 'block';
    }
  }
});